import { Controller } from "@hotwired/stimulus"
import { readMarkdownFromEditor } from "./helpers/lexxyEditorMarkdown"

export default class RawNotesContentController extends Controller {
  getContent() {
    return readMarkdownFromEditor(this.element.editor)
  }
}
